import React, { useEffect, useRef } from "react";
import { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Stack, Grid, CircularProgress } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { FormControl, Select, useMediaQuery, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import axios from "axios";
import dayjs from "dayjs";
import {
  ENQUIRY_TYPE,
  PROJECT,
  CATEGORY,
  LEAD_SOURCE,
  HOT_SUB_CATEGORY,
  WARM_SUB_CATEGORY,
  COLD_SUB_CATEGORY,
  CLOSED_SUB_CATEGORY,
  PENDING_SUB_CATEGORY,
  STATE_API,
  BDM_REMARK_UPDATE,
  CREATE_MEETING,
  CREATE_SITE_VISIT,
  CREATE_ESTIMATION,
  CHECK_OUT,
  GET_CATEGORY_AND_SUBCATEGORY_LIST,
  GET_BUISNESS_LIST,
  GET_NET_WORTH,
  GET_AVAILABLE_LAND,
} from "../../constants";
import bdmFormStyles from "../BDM Assigned Page/bdmFormStyles.module.css";
import imageCompression from "browser-image-compression";
import { offlineStorage } from "../../Utils/OfflineStorage";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

function DispositionModalComponent({
  open,
  setOpen,
  meetingFormData,
  siteVisitFormData,
  estimateFormData,
  setShowMeetingForm,
  setSiteVisitForm,
  setEstimationForm,
  setSeverity,
  setMessage,
  setOpenSnackbar,
  formType,
  setRunEffect,
  resetForm,
  handleCloseTaskDialog,
  setOpenTaskDialog,
  travelDetailsId,
  placeOfSubmit,
  fetchDailyTasks,
  handleCloseFormDialog,
  bdmLeadActionId,
  typeOfTask,
  showExtraFields
}) {
  const [followUpDate, setFollowUpDate] = useState(undefined);
  const [closureMonth, setClosureMonth] = useState(undefined);
  const [loading, setLoading] = useState(false);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const navigate = useNavigate();

  const handleClose = (event, reason) => {
    if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
      setOpen(false);
    }
  };

  useEffect(() => {
    handleGetCategoryAndSubCategory();
    handleGetBuisnessList();
    handleGetNetWorth();
    handleGetAvailableLand();
  }, []);

  const [selectedCategory, setSelectedCategory] = useState({
    id: null,
    name: "",
  });
  const [selectedSubCategory, setSelectedSubCategory] = useState({
    id: null,
    name: "",
  });

  const [categoryList, setCategoryList] = useState([]);
  const [categoryLoading, setCategoryLoading] = useState(false);

  const handleGetCategoryAndSubCategory = () => {
    setCategoryLoading(true); // Start loading
    axios
      .get(`${GET_CATEGORY_AND_SUBCATEGORY_LIST}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((response) => {
        setCategoryList(response.data);
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          handleLogout();
        } else {
          setCategoryError("Failed to fetch data. Please try again.");
        }
      })
      .finally(() => {
        setCategoryLoading(false); // Stop loading
      });
  };

  const [buisnessLoading, setBuisnessLoading] = useState(false);
  const [buisnessList, setBuisnessList] = useState([]);
  const [buisnessError, setBuisnessError] = useState("");
  const [buisnessCategory, setBuisnessCategory] = useState({
    id: null, name: "",});

  const handleGetBuisnessList = () => {
    setBuisnessLoading(true); 
    axios
      .get(`${GET_BUISNESS_LIST}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((response) => {
        setBuisnessList(response.data.data);
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          handleLogout();
        } else {
          setBuisnessError("Failed to fetch data. Please try again.");
        }
      })
      .finally(() => {
        setBuisnessLoading(false); // Stop loading
      });
  };

  const [netWorthLoading, setNetWorthLoading] = useState(false);
  const [netWorthList, setNetWorthList] = useState([]);
  const [netWorthError, setNetWorthError] = useState("");
  const [netWorthCategory, setNetWorthCategory] = useState({
    id: null, name: "",});

  const handleGetNetWorth = () => {
    setNetWorthLoading(true); 
    axios
      .get(`${GET_NET_WORTH}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((response) => {
        setNetWorthList(response.data.data);
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          handleLogout();
        } else {
          setNetWorthError("Failed to fetch data. Please try again.");
        }
      })
      .finally(() => {
        setNetWorthLoading(false); // Stop loading
      });
  }

  const [availableLandLoading, setAvailableLandLoading] = useState(false);
  const [availableLandList, setAvailableLandList] = useState([]);
  const [availableLandError, setAvailableLandError] = useState("");
  const [availableLandCategory, setAvailableLandCategory] = useState({
    id: null, name: "",});

  const handleGetAvailableLand = () => {
    setAvailableLandLoading(true); 
    axios
      .get(`${GET_AVAILABLE_LAND}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((response) => {
        setAvailableLandList(response.data.data);
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          handleLogout();
        } else {
          setAvailableLandError("Failed to fetch data. Please try again.");
        }
      })
      .finally(() => {
        setAvailableLandLoading(false); // Stop loading
      });
  };

  const handleLogout = () => {
      localStorage.clear();
      Cookies.remove("authToken", { path: "/" });
      navigate("/");
      navigate(0);
    };

  const [error, setError] = useState("");

  const handleFollowupDateTime = (e) => {
    const dateString = e.$d;

    // Create a new Date object from the given string
    const date = new Date(dateString);

    // Function to pad numbers with leading zeros
    const pad = (num) => (num < 10 ? "0" + num : num);

    // Extract date components
    const day = pad(date.getDate());
    const month = pad(date.getMonth() + 1);
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = pad(date.getMinutes());
    const ampm = hours >= 12 ? "PM" : "AM";

    // Convert hours to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12; // Handle midnight (0 hours)

    // Formatted date and time string
    const formattedDate = `${year}-${month}-${day}`;
    setFollowUpDate(formattedDate);
    if (formattedDate === undefined) {
      setError("Follow-up Date is required");
    } else {
      setError("");
    }

    // console.log(formattedDate);
  };

  const [ClosureMontherror, setClosureMonthError] = useState("");

  const handleChangeExpectedClosureMonth = (e) => {
    const dateString = e.$d;

    // Create a new Date object from the given string
    const date = new Date(dateString);

    // Array of month names
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    // Extract month and year
    const monthName = monthNames[date.getMonth()];
    const year = date.getFullYear();

    // Formatted string
    const formattedDate = `${monthName} ${year}`;
    setClosureMonth(formattedDate);

    if (formattedDate === undefined) {
      setClosureMonthError("Closure Month is required");
    } else {
      setClosureMonthError("");
    }
  };

  const [categoryError, setCategoryError] = useState("");
  const [subCategoryError, setSubCategoryError] = useState("");

  const compressImages = async (images) => {
    const options = {
      maxSizeMB: 0.1, // Maximum file size (e.g., 0.2 MB)
      maxWidthOrHeight: 800, // Max width or height
      useWebWorker: true,
    };

    try {
      const compressedImages = await Promise.all(
        images.map((image) => imageCompression(image, options))
      );
      return compressedImages;
    } catch (error) {
      console.error("Image compression failed:", error);
      return images; // Return original images if compression fails
    }
  };

  const handleSubmit = () => {
    let isValid = true;

    if (selectedCategory.name.trim() == "") {
      setCategoryError("Category is required.");
      isValid = false;
    }

    if (selectedSubCategory.name.trim() == "") {
      setSubCategoryError("Sub-Category is required");
      isValid = false;
    }

    if (
      selectedCategory.name.toLowerCase() == "hot" ||
      selectedCategory.name.toLowerCase() == "warm" ||
      selectedCategory.name.toLowerCase() == "pending"
    ) {
      if (followUpDate === undefined) {
        setError("Follow-up Date is required");
        isValid = false;
      }
    }

    if (
      selectedCategory.name.toLowerCase() == "hot" ||
      selectedCategory.name.toLowerCase() == "warm"
    ) {
      if (closureMonth === undefined) {
        setClosureMonthError("Closure Month is required");
        isValid = false;
      }
    }

    if (isValid) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;

          // Add geolocation data to the respective form data
          if (formType === "meeting") {
            meetingFormData.append(
              "category",
              selectedCategory.name.toLowerCase()
            );
            meetingFormData.append(
              "sub_category",
              selectedSubCategory.name.toLowerCase()
            );
            if (followUpDate !== undefined && followUpDate !== null) {
              meetingFormData.append("follow_up_date", followUpDate);
            }
            if (closureMonth !== undefined && closureMonth !== null) {
              meetingFormData.append("closure_month", closureMonth);
            }
            meetingFormData.append("bdmLeadActionId", bdmLeadActionId);
            meetingFormData.append("latitude", latitude);
            meetingFormData.append("longitude", longitude);
            meetingFormData.append("travelDetailId", travelDetailsId);
            meetingFormData.append("meeting_place", typeOfTask);
            meetingFormData.append("available_land", availableLandCategory.name);
            meetingFormData.append("net_worth", netWorthCategory.name);
            meetingFormData.append("current_business", buisnessCategory.name);

            handleMeetingSubmit(meetingFormData);
          } else if (formType === "site_visit") {
            siteVisitFormData.append(
              "category",
              selectedCategory.name.toLowerCase()
            );
            siteVisitFormData.append(
              "sub_category",
              selectedSubCategory.name.toLowerCase()
            );
            if (followUpDate !== undefined && followUpDate !== null) {
              siteVisitFormData.append("follow_up_date", followUpDate);
            }
            if (closureMonth !== undefined && closureMonth !== null) {
              siteVisitFormData.append("closure_month", closureMonth);
            }
            siteVisitFormData.append("bdmLeadActionId", bdmLeadActionId);
            siteVisitFormData.append("latitude", latitude);
            siteVisitFormData.append("longitude", longitude);
            siteVisitFormData.append("travelDetailId", travelDetailsId);

            handleSiteVisitSubmit(siteVisitFormData);
          } else if (formType === "estimate") {
            estimateFormData.category = selectedCategory.name.toLowerCase();
            estimateFormData.sub_category =
              selectedSubCategory.name.toLowerCase();
            if (followUpDate !== undefined && followUpDate !== null) {
              estimateFormData.follow_up_date = followUpDate;
            }
            if (closureMonth !== undefined && closureMonth !== null) {
              estimateFormData.closure_month = closureMonth;
            }

            handleEstimateSubmit(estimateFormData);
          }
        },
        (error) => {
          console.error("Geolocation error:", error);
          setSeverity("error");
          setMessage("Unable to retrieve your location.");
          setOpenSnackbar(true);
        }
      );
    } else {
      console.log("Form submission blocked due to validation errors.");
      setSeverity("error");
      setMessage("Please check for missing fields.");
      setOpenSnackbar(true);
    }
  };

  const handleMeetingSubmit = async (formData) => {
    setLoading(true);
    setOpen(false);
    let isSubmitted = false;

    const checkNetworkSpeed = async () => {
      if (!navigator.onLine)
        return { isGoodSpeed: false, networkDelay: Infinity };
      try {
        const startTime = Date.now();
        const response = await fetch("/api/ping", { timeout: 2000 });
        const endTime = Date.now();
        const networkDelay = endTime - startTime;
        return {
          isGoodSpeed: networkDelay < 2000 && response.ok,
          networkDelay,
        };
      } catch (error) {
        return { isGoodSpeed: false, networkDelay: Infinity };
      }
    };

    try {
      if (!navigator.onLine) {
        console.log("Offline, saving data to IndexedDB immediately.");
        const savedData = await offlineStorage.saveFormData(
          "meeting",
          formData
        );

        setSeverity("warning");
        setMessage(
          "No internet connection. Data will sync automatically when online."
        );
        setOpenSnackbar(true);
        setShowMeetingForm(false);
        setOpen(false);
        resetForm();
        setOpenTaskDialog(false);
        return setLoading(false);
      }

      const { isGoodSpeed, networkDelay } = await checkNetworkSpeed();
      if (isGoodSpeed) {
        try {
          const response = await axios.post(`${CREATE_MEETING}`, formData, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          });

          isSubmitted = true;
          setLoading(false);
          setSeverity("success");
          setMessage(response.data.message);
          setOpenSnackbar(true);
          setShowMeetingForm(false);
          setOpen(false);
          resetForm();
          // fetchDailyTasks();
          setOpenTaskDialog(false);
          setRunEffect(true);
          handleCloseFormDialog();
        } catch (error) {
          console.log("Request failed, saving to IndexedDB");
          const savedData = await offlineStorage.saveFormData(
            "meeting",
            formData
          );

          setLoading(false);
          setSeverity("warning");
          setMessage(
            `Slow network detected (${networkDelay}ms). Data saved offline and will sync automatically.`
          );
          setOpenSnackbar(true);
          setShowMeetingForm(false);
          setOpen(false);
          resetForm();
          setOpenTaskDialog(false);

          setTimeout(async () => {
            try {
              const checkResponse = await axios.post(
                `${CREATE_MEETING}`,
                formData,
                {
                  headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                      "authToken"
                    )}`,
                  },
                }
              );
              if (
                checkResponse.data.checkout.message ===
                "Check-out recorded successfully"
              ) {
                await offlineStorage.removePendingSubmission(
                  savedData.id,
                  "meeting"
                );
              }
            } catch (error) {
              if (
                error.response.data.message ===
                "Check-out already recorded for this travel detail"
              ) {
                // If record exists, remove from IDB
                await offlineStorage.removePendingSubmission(
                  savedData.id,
                  "meeting"
                );
                setSeverity("success");
                setMessage("Data Submitted..");
                setOpenSnackbar(true);
              }
              console.log("Background check failed, will retry later", error);
            }
          }, 10000);
        }
      } else {
        console.log("Network too slow, saving to IndexedDB.");
        const savedData = await offlineStorage.saveFormData(
          "meeting",
          formData
        );

        setSeverity("warning");
        setMessage(
          "Network is too slow. Data will sync when a better connection is available."
        );
        setOpenSnackbar(true);
        setShowMeetingForm(false);
        setOpen(false);
        resetForm();
        setOpenTaskDialog(false);
      }
    } catch (error) {
      console.error("Error in form submission:", error);
      setSeverity("error");
      setMessage("Error submitting form. Please try again.");
      setOpenSnackbar(true);
    } finally {
      setLoading(false);
    }
  };

  const handleSiteVisitSubmit = async (formData) => {
    setLoading(true);
    setOpen(false);
    let isSubmitted = false;

    const checkNetworkSpeed = async () => {
      if (!navigator.onLine)
        return { isGoodSpeed: false, networkDelay: Infinity };
      try {
        const startTime = Date.now();
        const response = await fetch("/api/ping", { timeout: 2000 });
        const endTime = Date.now();
        const networkDelay = endTime - startTime;
        return {
          isGoodSpeed: networkDelay < 2000 && response.ok,
          networkDelay,
        };
      } catch (error) {
        return { isGoodSpeed: false, networkDelay: Infinity };
      }
    };

    try {
      if (!navigator.onLine) {
        console.log(
          "Offline, saving site visit data to IndexedDB immediately."
        );
        const savedData = await offlineStorage.saveFormData(
          "site_visit",
          formData
        );

        setSeverity("warning");
        setMessage(
          "No internet connection. Data will sync automatically when online."
        );
        setOpenSnackbar(true);
        setSiteVisitForm(false);
        setOpen(false);
        resetForm();
        setOpenTaskDialog(false);
        return setLoading(false);
      }

      const { isGoodSpeed, networkDelay } = await checkNetworkSpeed();
      if (isGoodSpeed) {
        try {
          const response = await axios.post(`${CREATE_SITE_VISIT}`, formData, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          });

          isSubmitted = true;
          setLoading(false);
          setSeverity("success");
          setMessage(response.data.message);
          setOpenSnackbar(true);
          setSiteVisitForm(false);
          setOpen(false);
          resetForm();
          // fetchDailyTasks();
          setOpenTaskDialog(false);
          setRunEffect(true);
          handleCloseFormDialog();
        } catch (error) {
          console.log("Request failed, saving site visit data to IndexedDB.");
          const savedData = await offlineStorage.saveFormData(
            "site_visit",
            formData
          );

          setTimeout(async () => {
            try {
              const checkResponse = await axios.post(
                `${CREATE_SITE_VISIT}`,
                formData,
                {
                  headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                      "authToken"
                    )}`,
                  },
                }
              );
              if (
                checkResponse.data.checkout.message ===
                "Check-out recorded successfully"
              ) {
                await offlineStorage.removePendingSubmission(
                  savedData.id,
                  "site_visit"
                );
              }
            } catch (error) {
              if (
                error.response.data.message ===
                "Check-out already recorded for this travel detail"
              ) {
                // If record exists, remove from IDB
                await offlineStorage.removePendingSubmission(
                  savedData.id,
                  "site_visit"
                );
                setSeverity("success");
                setMessage("Data Submitted..");
                setOpenSnackbar(true);
              }
              console.log("Background sync failed, will retry later", error);
            }
          }, 10000);

          setLoading(false);
          setSeverity("warning");
          setMessage(
            `Slow network detected (${networkDelay}ms). Data saved offline and will sync automatically.`
          );
          setOpenSnackbar(true);
          setSiteVisitForm(false);
          setOpen(false);
          resetForm();
          setOpenTaskDialog(false);
        }
      } else {
        console.log("Network too slow, saving site visit data to IndexedDB.");
        const savedData = await offlineStorage.saveFormData(
          "site_visit",
          formData
        );
        setLoading(false);
        setSeverity("warning");
        setMessage(
          "Network is too slow. Data will sync when a better connection is available."
        );
        setOpenSnackbar(true);
        setSiteVisitForm(false);
        setOpen(false);
        resetForm();
        setOpenTaskDialog(false);
      }
    } catch (error) {
      console.error("Error in site visit form submission:", error);
      setSeverity("error");
      setMessage("Error submitting form. Please try again.");
      setOpenSnackbar(true);
    } finally {
      setLoading(false);
    }
  };

  // const handleSiteVisitSubmit = (formData) => {
  //   setLoading(true);
  //   setOpen(false);
  //   axios
  //     .post(CREATE_SITE_VISIT, formData, {
  //       headers: {
  //         Authorization: `Bearer ${localStorage.getItem("authToken")}`,
  //       },
  //     })
  //     .then((response) => {
  //       console.log(response.data);
  //       setLoading(false);
  //       setSeverity("success");
  //       setMessage(response.data.message);
  //       setOpenSnackbar(true);
  //       setSiteVisitForm(false);
  //       setRunEffect(true);
  //       setOpen(false);
  //       resetForm();
  //       if (placeOfSubmit === "Todo") {
  //         handleCheckout();
  //       }
  //       setOpenTaskDialog(false);
  //       handleCloseFormDialog();
  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //       if (error.response) {
  //         console.log(error.response.data.message);
  //         setSiteVisitForm(false);
  //         setSeverity("error");
  //         setMessage(error.response.data.message);
  //         setOpenSnackbar(true);
  //         setRunEffect(false);
  //         setOpen(false);
  //         resetForm();
  //       } else if (error.request) {
  //         // The request was made but no response was received
  //         console.log(error.response.data.message);
  //         setSeverity("error");
  //         setMessage("Internal Server Error.");
  //         setOpenSnackbar(true);
  //         setSiteVisitForm(false);
  //         setRunEffect(false);
  //         setOpen(false);
  //         resetForm();
  //       }
  //     });
  // };

  const handleEstimateSubmit = (formData) => {
    setLoading(true);
    setOpen(false);
    axios
      .post(CREATE_ESTIMATION, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((response) => {
        console.log(response.data);
        setLoading(false);
        setSeverity("success");
        setMessage(response.data.message);
        setOpenSnackbar(true);
        setEstimationForm(false);
        setRunEffect(true);
        setOpen(false);
        resetForm();

        handleCloseFormDialog();
      })
      .catch((error) => {
        console.log(error.response);
        setLoading(false);
        if (error.response) {
          console.log(error.response.data.error);
          setEstimationForm(false);
          setSeverity("error");
          setMessage(error.response.data.error);
          setOpenSnackbar(true);
          setRunEffect(false);
          setOpen(false);
          resetForm();
        } else if (error.request) {
          // The request was made but no response was received
          console.log(error.response.data.error);
          setSeverity("error");
          setMessage("Internal Server Error.");
          setOpenSnackbar(true);
          setEstimationForm(false);
          setRunEffect(false);
          setOpen(false);
          resetForm();
        }
      });
  };

  const handleReset = () => {
    setSelectedCategory({ id: null, name: "" });
    setSelectedSubCategory({ id: null, name: "" });
    setFollowUpDate(undefined);
    setClosureMonth(undefined);

    setEnableField(false);
    setShowField(false);
    setError("");
    setClosureMonthError("");
    setCategoryError("");
    setSubCategoryError("");
  };

  const handleCheckout = () => {
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;

        // Create the payload with the task details and location data
        const payload = {
          travelDetailId: travelDetailsId,
          latitude: latitude,
          longitude: longitude,
        };

        try {
          const response = await axios.post(`${CHECK_OUT}`, payload);

          console.log(response.data);
          fetchDailyTasks();
        } catch (error) {
          console.error("Error submitting actions:", error);
        }
      },
      (error) => {
        // Handle error when geolocation fails
        console.error("Error fetching location:", error);
        // Set a fallback location or show an error message
      },
      {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      }
    );
  };

  const [showField, setShowField] = useState(false);
  const [enableField, setEnableField] = useState(false);

  const feildsShow = (cat) => {
    if (cat == "hot" || cat == "warm") {
      setEnableField(true);
    } else {
      setEnableField(false);
    }
    if (cat == "pending") {
      setShowField(true);
    } else {
      setShowField(false);
    }
  };

  const inputRef = useRef(null);

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        disableEscapeKeyDown
        fullScreen={fullScreen} // Adjusts dialog size based on screen width
        maxWidth="sm" // Limits maximum width of the dialog
        fullWidth // Ensures dialog takes full width of the screen
        scroll="paper" // Enables scrolling if content overflows
      >
        <DialogTitle
          sx={{
            background: (theme) => theme.palette.primary.main,
            color: "#fff",
          }}
        >
          Add Category
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "#fff",
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers>
          <Box
            component="form"
            sx={{
              "& .MuiTextField-root": { m: 1, width: "100%" }, // Adjust width for small screens
              "@media (max-width: 600px)": {
                "& .MuiTextField-root": { m: 1, width: "100%" }, // Full width on mobile
              },
            }}
            noValidate
            autoComplete="off"
          >
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextField
                  select
                  label="Category"
                  value={selectedCategory.name}
                  fullWidth
                  onChange={(e) => {
                    const selected = categoryList.find(
                      (cat) => cat.CategoryName === e.target.value
                    );
                    if (selected) {
                      setSelectedCategory({
                        id: selected.CategoryId,
                        name: selected.CategoryName,
                      });
                      setSelectedSubCategory({ id: null, name: "" }); // reset subcategory
                      setCategoryError("");
                      feildsShow(selected.CategoryName.toLowerCase());
                    } else {
                      setCategoryError("Category is required.");
                    }
                  }}
                  size="small"
                  required
                  error={!!categoryError}
                  helperText={categoryError}
                >
                  {categoryList.map((cat) => (
                    <MenuItem key={cat.CategoryId} value={cat.CategoryName}>
                      {cat.CategoryName}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  select
                  label="Sub-Category"
                  value={selectedSubCategory.name}
                  fullWidth
                  onChange={(e) => {
                    const subcats =
                      categoryList.find(
                        (cat) => cat.CategoryId === selectedCategory.id
                      )?.subcategories || [];

                    const selectedSub = subcats.find(
                      (sub) => sub.SubCategoryName === e.target.value
                    );

                    if (selectedSub) {
                      setSelectedSubCategory({
                        id: selectedSub.SubCategoryId,
                        name: selectedSub.SubCategoryName,
                      });
                      setSubCategoryError("");
                    } else {
                      setSubCategoryError("Sub-Category is required.");
                    }
                  }}
                  size="small"
                  required
                  error={!!subCategoryError}
                  helperText={subCategoryError}
                >
                  {categoryList
                    .find((cat) => cat.CategoryId === selectedCategory.id)
                    ?.subcategories.map((sub) => (
                      <MenuItem
                        key={sub.SubCategoryId}
                        value={sub.SubCategoryName}
                      >
                        {sub.SubCategoryName}
                      </MenuItem>
                    ))}
                </TextField>
              </Grid>

              {(enableField || showField) && (
                <Grid item xs={12} md={6}>
                  <DatePicker
                    label="Follow-up Date"
                    onChange={handleFollowupDateTime}
                    disablePast
                    shouldDisableDate={(date) => {
                      // Disable today
                      const today = dayjs().startOf("day");
                      return date.isSame(today, "day");
                    }}
                    slotProps={{
                      textField: {
                        error: !!error,
                        helperText: error,
                      },
                      popper: {
                        modifiers: [
                          {
                            name: "flip",
                            options: {
                              fallbackPlacements: ["top"], // Forces the popper to open on top
                            },
                          },
                        ],
                      },
                    }}
                  />
                </Grid>
              )}

              {enableField && (
                <Grid item xs={12} md={6}>
                  <DatePicker
                    label="Closure Month"
                    views={["month", "year"]}
                    onChange={handleChangeExpectedClosureMonth}
                    disablePast
                    slotProps={{
                      textField: {
                        error: !!ClosureMontherror,
                        helperText: ClosureMontherror,
                      },
                      popper: {
                        modifiers: [
                          {
                            name: "flip",
                            options: {
                              fallbackPlacements: ["top"], // Forces the popper to open on top
                            },
                          },
                        ],
                      },
                    }}
                  />
                </Grid>
              )}

              {showExtraFields && (<>
              <Grid item xs={12} md={6}>
                <TextField
                  select
                  label="Current Buisness"
                  value={buisnessCategory.name}
                  fullWidth
                  onChange={(e) => {
                    const selected = buisnessList.find(
                      (cat) => cat.name === e.target.value
                    );
                    if (selected) {
                      setBuisnessCategory({
                        id: selected.id,
                        name: selected.name,
                      });
                      setBuisnessError("");
                      
                    } else {
                      setBuisnessError("Buisness is required.");
                    }
                  }}
                  size="small"
                  
                  error={!!buisnessError}
                  helperText={buisnessError}
                >
                  {buisnessList.map((cat) => (
                    <MenuItem key={cat.id} value={cat.name}>
                      {cat.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  select
                  label="Net Worth"
                  value={netWorthCategory.name}
                  fullWidth
                  onChange={(e) => {
                    const selected = netWorthList.find(
                      (cat) => cat.name === e.target.value
                    );
                    if (selected) {
                      setNetWorthCategory({
                        id: selected.id,
                        name: selected.name,
                      });
                      setNetWorthError("");
                      
                    } else {
                      setNetWorthError("Net-Worth is required.");
                    }
                  }}
                  size="small"
                  
                  error={!!netWorthError}
                  helperText={netWorthError}
                >
                  {netWorthList.map((cat) => (
                    <MenuItem key={cat.id} value={cat.name}>
                      {cat.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              
              <Grid item xs={12} md={6}>
                <TextField
                  select
                  label="Available Land"
                  value={availableLandCategory.name}
                  fullWidth
                  onChange={(e) => {
                    const selected = availableLandList.find(
                      (cat) => cat.name === e.target.value
                    );
                    if (selected) {
                      setAvailableLandCategory({
                        id: selected.id,
                        name: selected.name,
                      });
                      setAvailableLandError("");
                      
                    } else {
                      setAvailableLandError("Available Land is required.");
                    }
                  }}
                  size="small"
                  error={!!availableLandError}
                  helperText={availableLandError}
                >
                  {availableLandList.map((cat) => (
                    <MenuItem key={cat.id} value={cat.name}>
                      {cat.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              </>)}

            </Grid>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleReset}>Reset</Button>
          <Button onClick={handleSubmit}>Save</Button>
        </DialogActions>
      </Dialog>

      {loading && (
        <Box
          sx={{
            position: "fixed", // Or 'absolute' depending on your layout
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: (theme) => theme.zIndex.modal + 1, // Higher than dialog z-index
          }}
        >
          <CircularProgress />
        </Box>
      )}
    </>
  );
}

export default DispositionModalComponent;
